import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "loc-pin",
  "use": "loc-pin-usage",
  "viewBox": "0 0 15 21",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 15 21\" id=\"loc-pin\"><path fill=\"red\" fill-rule=\"evenodd\" d=\"M7.5 0A7.3 7.3 0 0 0 0 7.2C0 11.2 7.5 21 7.5 21S15 11.2 15 7.2 11.7 0 7.5 0m0 11C5.5 11 4 9.5 4 7.5S5.5 4 7.5 4 11 5.5 11 7.5 9.5 11 7.5 11\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol